import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilePencilAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.66665 2H5.46665C4.71991 2 4.34654 2 4.06133 2.14532C3.81044 2.27316 3.60647 2.47713 3.47864 2.72801C3.33331 3.01323 3.33331 3.3866 3.33331 4.13333V11.8667C3.33331 12.6134 3.33331 12.9868 3.47864 13.272C3.60647 13.5229 3.81044 13.7268 4.06133 13.8547C4.34654 14 4.71991 14 5.46665 14H6.66665M8.66665 2L12.6666 6M8.66665 2V4.93333C8.66665 5.3067 8.66665 5.49339 8.73931 5.63599C8.80322 5.76144 8.90521 5.86342 9.03065 5.92734C9.17326 6 9.35995 6 9.73331 6H12.6666M12.6666 6V6.66667M5.99998 11.3333H7.66665M5.99998 8.66667H9.33331M5.99998 6H6.66665M9.33331 14L10.6833 13.73C10.801 13.7065 10.8599 13.6947 10.9147 13.6732C10.9635 13.6541 11.0097 13.6293 11.0527 13.5993C11.101 13.5656 11.1435 13.5232 11.2283 13.4383L14 10.6667C14.3682 10.2985 14.3682 9.70152 14 9.33333C13.6318 8.96514 13.0348 8.96514 12.6666 9.33333L9.89501 12.105C9.81013 12.1898 9.76769 12.2323 9.73397 12.2806C9.70403 12.3236 9.67926 12.3699 9.66015 12.4186C9.63862 12.4735 9.62685 12.5323 9.60331 12.65L9.33331 14Z",
		stroke: "#363636",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFilePencilAlt;
